import {
  TREQUEST_FabricStorageGRNDetails,
  TREQUEST_FabricStorageRollsDetails,
  TREQUEST_TrimsStorageGRNDetails,
  TREQUEST_TrimsStorageItemDetails,
  TRESPONSE_FabricStorageGRNDetails,
  TRESPONSE_FabricStorageRollsDetails,
  TRESPONSE_TrimsStorageGRNDetails,
  TRESPONSE_TrimsStorageItemDetails,
} from '@monorepo/types';
import { Action } from '@ngrx/store';

export enum StorageDBActions {
  ClearAndFetchFabricStorageGRNDetails = 'ClearAndFetchFabricStorageGRNDetails',
  ClearAndFetchFabricStorageGRNDetailsSuccess = 'ClearAndFetchFabricStorageGRNDetailsSuccess',
  ClearAndFetchTrimsStorageGRNDetails = 'ClearAndFetchTrimsStorageGRNDetails',
  ClearAndFetchTrimsStorageGRNDetailsSuccess = 'ClearAndFetchTrimsStorageGRNDetailsSuccess',
  ClearAndFetchFabricStorageRollsDetails = 'ClearAndFetchFabricStorageRollsDetails',
  ClearAndFetchFabricStorageRollsDetailsSuccess = 'ClearAndFetchFabricStorageRollsDetailsSuccess',
  ClearAndFetchTrimsStorageItemDetails = 'ClearAndFetchTrimsStorageItemDetails',
  ClearAndFetchTrimsStorageItemDetailsSuccess = 'ClearAndFetchTrimsStorageItemDetailsSuccess',

  StorageNoAction = 'StorageNoAction',
}

export class ClearAndFetchFabricStorageGRNDetails implements Action {
  readonly type = StorageDBActions.ClearAndFetchFabricStorageGRNDetails;
  constructor(public payload: TREQUEST_FabricStorageGRNDetails) {}
}

export class ClearAndFetchFabricStorageGRNDetailsSuccess implements Action {
  readonly type = StorageDBActions.ClearAndFetchFabricStorageGRNDetailsSuccess;
  constructor(public res: TRESPONSE_FabricStorageGRNDetails) {}
}

export class ClearAndFetchTrimsStorageGRNDetails implements Action {
  readonly type = StorageDBActions.ClearAndFetchTrimsStorageGRNDetails;
  constructor(public payload: TREQUEST_TrimsStorageGRNDetails) {}
}

export class ClearAndFetchTrimsStorageGRNDetailsSuccess implements Action {
  readonly type = StorageDBActions.ClearAndFetchTrimsStorageGRNDetailsSuccess;
  constructor(public res: TRESPONSE_TrimsStorageGRNDetails) {}
}
export class ClearAndFetchFabricStorageRollsDetails implements Action {
  readonly type = StorageDBActions.ClearAndFetchFabricStorageRollsDetails;
  constructor(public payload: TREQUEST_FabricStorageRollsDetails) {}
}
export class ClearAndFetchFabricStorageRollsDetailsSuccess implements Action {
  readonly type = StorageDBActions.ClearAndFetchFabricStorageRollsDetailsSuccess;
  constructor(public res: TRESPONSE_FabricStorageRollsDetails) {}
}
export class ClearAndFetchTrimsStorageItemDetails implements Action {
  readonly type = StorageDBActions.ClearAndFetchTrimsStorageItemDetails;
  constructor(public payload: TREQUEST_TrimsStorageItemDetails) {}
}
export class ClearAndFetchTrimsStorageItemDetailsSuccess implements Action {
  readonly type = StorageDBActions.ClearAndFetchTrimsStorageItemDetailsSuccess;
  constructor(public res: TRESPONSE_TrimsStorageItemDetails) {}
}

export class StorageNoAction implements Action {
  readonly type = StorageDBActions.StorageNoAction;
  constructor() {}
}

export type TStorageDBActionTypes =
  | ClearAndFetchFabricStorageGRNDetails
  | ClearAndFetchFabricStorageGRNDetailsSuccess
  | ClearAndFetchTrimsStorageGRNDetails
  | ClearAndFetchTrimsStorageGRNDetailsSuccess
  | ClearAndFetchFabricStorageRollsDetails
  | ClearAndFetchFabricStorageRollsDetailsSuccess
  | ClearAndFetchTrimsStorageItemDetails
  | ClearAndFetchTrimsStorageItemDetailsSuccess
  | StorageNoAction;
